<template>
  <div>

    <data-table
      title="Master Workflow"
      title-heading="h2"
      icon="fa fa-cogs"

      ref="workflow"
      tableRef="workflowtable"

      url="/workflow"

      :fields="listFields"

      sort-field="id"
      :show-search="false"

      hide-org-badge

      detail-component="workflow-row"

      :addAction='addActionComp'>


      <template #name="props">
        <span v-if="props.rowData.name && props.rowData.type">{{props.rowData.type}}: <b class="text-primary">{{props.rowData.name}}</b></span>
        <span v-else class="text-primary">{{props.rowData.name}}</span>
      </template>

      <template #view="props">
        <center>
          <el-button type="text" size="mini" round plain icon="fa fa-angle-double-down" @click="showDetail(props.rowData.id)">
            &nbsp;Show
          </el-button>
          </center>
      </template>



      <template #deleteRow="props">
        <el-button
            v-if="isManager('project|maintenance')"
            class="pull-right"
            size="small"
            type="danger"
            circle
            @click="onDelete(props.rowData)"
            :disabled="props.rowData.activeSites > 0">
          <i class="fa fa-trash"></i>
        </el-button>
      </template>


    </data-table>
  </div>
</template>

<script>
import Vue from 'vue'

import WorkflowMixins from '@/mixins/WorkflowMixins'

import AddWorkflow from '@/components/workflow/AddWorkflow'
import WorkflowDetails from '@/components/workflow/WorkflowDetails'

Vue.component('workflow-row', WorkflowDetails)

export default {
  mixins: [WorkflowMixins],

  components: {
    WorkflowDetails,
    AddWorkflow
  },

  props: {
    sharer: {
      type: Number,
      default: null
    },
    rowData: {
      type: Object
    },
    rowIndex: {
      type: Number
    }
  },

  methods: {
    onDelete (row) {
      this.deleteItem(this, row.id, '/workflow', row.name ? row.name : 'Worklfow', null, true, this.WORKFLOW_TABLE_REF)
    },

    showDetail (id) {
      let table = this.$refs.workflow.$refs.workflowtable
      table.toggleDetailRow(id)
    }


  },

  watch: {
    data (newVal, oldVal) {
      this.$refs.workflowtable.refresh()
    }
  },

  data () {
    return {
      addActionComp: AddWorkflow,
      lastIndex: null,
      telcoId: this.sharer,
      perPage: 15,
      hideTop: true,
      listFields: [
        {
          name: '__sequence',
          title: '#',
          width: '3em'
        },
        {
          title: '<i class="fa fa-list">&nbsp;</i>Workflow',
          name: '__slot:name'
        },
        {
          name: 'totalChecklists',
          title: '<i class="fa fa-tasks">&nbsp;</i>Tasks',
          dataClass: 'text-primary'
        },
        {
          name: 'totalFiles',
          title: '<i class="fa fa-folder-tree">&nbsp;</i>Files',
          dataClass: 'text-primary'
        },
        {
          title: '<i class="fa fa-users"></i> (est.)',
          name: 'workforceReq',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-info'
        },
        {
          name: 'activeSites',
          title: '# <i class="fa fa-broadcast-tower">&nbsp;</i>Sites',
          dataClass: 'text-primary',
          width: '5em'
        },
        {
          name: '__slot:view'
        },
        {
          name: '__slot:deleteRow'
        }
      ]
    }
  }

}
</script>
